export class VerifyCompanyDomainPayload {
  public email: string;
  public appId: number;
  public timestamp: number;
}

export class VerifyCompanyDomainResponse {
  companyId: number;
  companyNameTh: string;
  companyNameEn: string;
}



// WEBPACK FOOTER //
// ./src/app/services/user/payload/verify-company-domain.payload.ts